/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Professional user type identifier
 */
export enum ProfessionalPrivateProfileType {
  PROFESSIONAL = 'PROFESSIONAL'
}
